/*
 * <input type="datetime-local"> works in the staff member's local time; the Admin API takes UTC.
 * Used by every form with a validity window (coupons, global discounts).
 */

/** datetime-local value (local time) for an ISO instant. */
export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

/** UTC ISO instant for a datetime-local value. */
export function fromLocalInput(value: string): string {
  return new Date(value).toISOString();
}
